import React from 'react'
import PlayerHistoryHomeNavigation from './PlayerHistoryHomeNavigation'
import './StatsAndStandingsHome.css'
import Banner from './Banner'
import SearchForPlayer from '../UIElements/SearchForPlayer'

const PlayerHistoryHome = () => {
	return (
		<div>
			{/* StatsAndStandingsHomeNavigation contains HomeHeader (just says Stats & Standings)
			and the HomeNavLinks (which is the ADMIN button on the far right) */}
			<PlayerHistoryHomeNavigation />
			<Banner />
			<div style={{ marginTop: '2rem' }}>
				<SearchForPlayer />
			</div>
			{/* <div className='rem'>
				<Footer />
			</div> */}
		</div>
	)
}

export default PlayerHistoryHome
